import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { annulUserError, deleteAdmin, deleteUser, getAllAdminsFull, getAllUsersFull } from '../../reducers/user/duck';
import { setAlertStatus } from '../../reducers/alert-ui/duck';
import { annulAdminError, createAdminUser, updateCreateAdminModal } from '../../reducers/create-admin/duck';

import AdminsScreen from './AdminsScreen';

const mapStateToProps = ({
  userStore: {
    sidebarStatus,
    usersFull,
    usersFullStatus,
    hasMoreUsersFull,
    adminsFull,
    adminsFullStatus,
    hasMoreAdminsFull,
  },
  createAdminStore: {
    createModalStatus,
    status,
    error,
  },
}) => ({
  sidebarStatus,
  createModalStatus,
  hasMoreUsersFull,
  usersFullStatus,
  usersFull,
  adminsFull,
  adminsFullStatus,
  hasMoreAdminsFull,
  status,
  error,
});

const mapDispatchToProps = {
  getAllUsersFull,
  getAllAdminsFull,
  deleteUser,
  deleteAdmin,
  setAlertStatus,
  updateCreateAdminModal,
  annulAdminError,
  annulUserError,
  createAdminUser,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminsScreen));



// WEBPACK FOOTER //
// ./src/containers/AdminsScreen/index.js